import { Control, Controller, FieldValues, Path } from "react-hook-form";
import AddressAutocompleteInput, {
  type AddressAutocompleteUpdateHandler,
} from "../../AddressAutocompleteInput";

export default function InternationalAddressAutocompleteInput({
  control,
  name,
  countries,
  label,
  onUpdate,
  isInternational,
  error,
  ...props
}: {
  control: Control<FieldValues>;
  name: Path<FieldValues>;
  label: string;
  onUpdate: CallableFunction;
  countries?: string[];
  isInternational?: boolean;
  error?: any;
}) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, onBlur }, fieldState: { error: fieldError } }) => (
        <AddressAutocompleteInput
          {...props}
          onChange={onChange}
          value={value}
          error={fieldError?.message || error || ""}
          onBlur={onBlur}
          label={label}
          onUpdate={onUpdate as AddressAutocompleteUpdateHandler}
          countries={countries}
          isInternational={isInternational}
        />
      )}
    />
  );
}
